<template>
  <div class="text-center">
    <v-dialog
      v-model='loading'
      persistent
      max-width="40%"
      >
      <v-card class="pa-0">
        <v-progress-circular
          indeterminate
          color="error">
        </v-progress-circular>
        <span style="font-size: 14px;">{{ status }}</span>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['loading', 'status'],
  data () {
    return {
    }
  }
}
</script>

<style>
.v-progress-circular {
  margin: 1rem;
}
</style>
